<template>
  <div>
    <datatable
      title="Admin Huji"
      @create="createHujiPosition"
      @delete="deleteHujiPosition"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-huji',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'title',
          value: 'title'
        },
        {
          name: 'position_applicant_code',
          value: 'position_applicant_code'
        }
      ],
      data: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllHujiPositions().then(response => {
        this.data = response
      })
    },
    createHujiPosition () {
      this.create({ designator: 'admin-huji-form-modal', component_name: 'AdminHujiPositionForm', is_create: true, modal_title: 'Create Huji Position' })
    },
    deleteHujiPosition (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.title,
        item_name: delete_data.title,
        method: 'deleteHujiPosition',
        method_params: { id: delete_data.id }
      })
    },
    editClick (data) {
      this.create({ designator: 'admin-huji-form-modal', component_name: 'AdminHujiPositionForm', data, modal_title: data.title })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
